import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { IconAction } from "./icon.action";
import { IconState } from "./icon.model";

const initialState: IconState = {
	isBusy: false,
	icons: {},
};

export const iconReducer = createReducer(
	initialState,
	on(IconAction.getAll, (state) =>
		updateState(state, {
			isBusy: true,
		})
	),
	on(IconAction.getAllSuccess, (state, { payload }) =>
		updateState(state, {
			icons: payload,
			isBusy: false,
		})
	),
	on(IconAction.getAllFail, (state) =>
		updateState(state, {
			isBusy: false,
		})
	)
);
